import { FieldArray, useField } from 'formik';

import {
  AUDIENCE_TARGET_TYPE,
  DemographicFormData,
  isMultiSelectLogicalModifier,
  Quota as TargetType,
  getEmptyQuotaRangeConstraint,
} from '../../../../util/demographics';
import { AudienceGroupOption } from '../../../../types/domainModels';

import AddButton from 'components/common/forms/AddButton';
import FormSearchSelectInput from 'components/common/forms/FormSearchSelectInput';
import FormInput from 'components/common/forms/FormInput';
import XButton from 'components/common/forms/XButton';

export const TargetConstraints = ({
  audienceGroupOptions,
  namePrefix,
  selectedAudienceGroupId,
}: {
  audienceGroupOptions: AudienceGroupOption[];
  namePrefix: string;
  selectedAudienceGroupId: number;
}): JSX.Element | null => {
  const selectionsFieldName = `${namePrefix}.audienceGroupOptionSelections`;
  const [{ value: logicalModifier }] = useField<TargetType['logicalModifier']>(
    `${namePrefix}.logicalModifier`,
  );
  const selectionsNumberRange = `${namePrefix}.numberRange`;
  const [{ value: numberRange }] = useField<
    DemographicFormData['audienceProfile']['audienceTargets'][number]['surveyAudienceTypes'][number]['numberRange']
  >(`${namePrefix}.numberRange`);
  const selectionsNumberSelections = `${namePrefix}.numberSelections`;

  if (selectedAudienceGroupId === AUDIENCE_TARGET_TYPE.RANGE) {
    return (
      <FieldArray
        name={selectionsNumberRange}
        render={(arrayHelpers) => {
          return (
            <div>
              <div className="space-y-2">
                {numberRange.map((_constraint, index) => {
                  return (
                    <div key={index} className="flex space-x-2">
                      <div>
                        <FormInput
                          name={`${selectionsNumberRange}.${index}.start`}
                          size="md"
                          type="number"
                        />
                      </div>
                      <span className="flex-shrink-0 mt-1 mx-4 text-sm">
                        and
                      </span>
                      <div>
                        <FormInput
                          name={`${selectionsNumberRange}.${index}.end`}
                          size="md"
                          type="number"
                        />
                      </div>
                      {numberRange.length > 1 && (
                        <div className="mt-2">
                          <XButton
                            onClick={() => {
                              arrayHelpers.remove(index);
                            }}
                            title="Remove"
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="flex mt-1">
                <AddButton
                  label={
                    logicalModifier?.value === 'should' ||
                    logicalModifier?.value === 'shouldnt'
                      ? 'or'
                      : 'and'
                  }
                  onClick={() => {
                    arrayHelpers.push(getEmptyQuotaRangeConstraint());
                  }}
                />
              </div>
            </div>
          );
        }}
      />
    );
  } else if (selectedAudienceGroupId === AUDIENCE_TARGET_TYPE.OPEN_END) {
    return <FormInput name={selectionsNumberSelections} size="md" />;
  }
  return (
    <FormSearchSelectInput
      borderColor="#D9D9D9"
      isMulti={
        logicalModifier
          ? isMultiSelectLogicalModifier(logicalModifier.value)
          : false
      }
      name={selectionsFieldName}
      options={audienceGroupOptions.map((option) => {
        return {
          label: option.name,
          value: option,
        };
      })}
    />
  );
};
